<template>
  <BaseButton type="button" primary outline small @click="onRevoke"> Revoke </BaseButton>
</template>

<script>
import { projectAssetApprovalRequestsClient } from '@/api/clients';

export default {
  props: {
    approvalRequestId: {
      type: String,
      required: true,
    },
    projectAssetId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async onRevoke() {
      this.loading = true;
      try {
        await projectAssetApprovalRequestsClient.destroy(
          this.projectAssetId,
          this.approvalRequestId,
          { soft: true }
        );

        this.$emit('approval-request-revoked');
      } catch (error) {
        // handle error
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
